import { AxiosError, isAxiosError } from 'axios';
import i18n from 'i18next';

export class RequestTimeoutError extends Error {
  constructor() {
    super('Api Request take too long');
  }
}

export class UnauthorizedAxiosError extends Error {
  readonly status: number = 401;

  constructor(error?: AxiosError) {
    super(error?.message ?? i18n.t('ERRORS.UNAUTHORIZED_ACTION', { ns: 'global' }));
  }
}

export class ForbiddenAxiosError extends Error {
  readonly status: number = 403;

  constructor(error?: AxiosError) {
    super(error?.message ?? i18n.t('ERRORS.FORBIDDEN_ACTION', { ns: 'global' }));
  }
}

export function onRequestError(error: { code?: string } | AxiosError): RequestTimeoutError | Error {
  if (error?.code === 'ECONNABORTED') {
    throw new RequestTimeoutError();
  }

  if (isAxiosError(error)) {
    if (error?.response?.status === 401) {
      throw new UnauthorizedAxiosError();
    }

    if (error?.response?.status === 403) {
      throw new ForbiddenAxiosError(error?.response?.data);
    }
  }

  throw error;
}
